var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-50 min-h-screen",attrs:{"id":"app"}},[(_vm.showTopBar)?_c('TopBar'):_vm._e(),_c('router-view'),(_vm.showTabBar)?_c('TabBar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }